import React from 'react'
function TH(props) {
    return(
    <th style={( !!props.width ) ? {textAlign:'center',width:props.width} : {textAlign:'center'}}>
        {props.children}
    </th>
    )
}
export default TH;